import { render, staticRenderFns } from "./RuleModal.vue?vue&type=template&id=0cd936ac&scoped=true"
import script from "./RuleModal.vue?vue&type=script&lang=js"
export * from "./RuleModal.vue?vue&type=script&lang=js"
import style0 from "./RuleModal.vue?vue&type=style&index=0&id=0cd936ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd936ac",
  null
  
)

export default component.exports